'use strict';

var App = require('app');
var Consts = require('consts');

var SidebarController = require('components/sidebar/sidebar_controller');

var SidebarComponent = {};

function buildSideBarCategoryFunc(category) {
    return function (id, permissions, active, userDefNames) {
        SidebarController.showCategorySidebar(id, permissions, active, userDefNames, category);
    };
}

_.each(Consts.CategoryData, function (data, category) {
    App.on('sidebar:' + data.type, buildSideBarCategoryFunc(category));
});

App.on('sidebar:default', function (active) {
    SidebarController.showDefaultSidebar(active);
});

App.on('sidebar:profile', function (id, active, featureFlags) {
    SidebarController.showProfileSidebar(id, active, featureFlags);
});

App.on('sidebar:change', function (entryParams) {
    SidebarController.showSidebar(entryParams);
});

SidebarComponent.initialize = function () {
    _.each(Consts.DeviceCategory, function (data, category) {
        App.on('sidebar:' + category, buildSideBarCategoryFunc(category));
    });
};

module.exports = SidebarComponent;
